/**
 *
 */
export default class OfflineViewer {
    constructor() {
        this.bindButtonsActions();
        this.bindEventListener();
        this._position = 0;
    }

    savePositions() {
        this._position = $(".overview-item-container").scrollTop();
        this._category = new URL(location.href).searchParams.get("category");
    }
    setScroll() {
        $(".overview-item-container").scrollTop(this._position);
        this._position = 0;
    }
    /**
     * An issue is clicked, do action
     *
     * @method issueClicked
     * @param {HTMLElement} target
     */
    issueClicked(event) {
        //we can do offline stuff. sendOVMessage is injected by the offline-viewer
        let target = $(event.currentTarget),
            issue_id = target.data("issueId"),
            message;

        if ($(event.target).hasClass("button-delete")) {
            message = "Remove"; //delete issue
        } else if (target.find(".download-button").hasClass("update")) {
            message = "Update"; //update issue
        } else if (target.find(".download-button").get(0)) {
            message = "Download"; //download issue
        } else {
            let url = "/" + window.client_id + "/issues/" + issue_id + "/native/index.html";
            return this.sendOfflineMessage("Open", url);
        }

        if (message) {
            event.preventDefault();
            event.stopPropagation();
            this.sendOfflineMessage(message, issue_id);
        }
    }

    bindButtonsActions() {
        $(document)
            .off("click.default")
            .on("click.default", ".issue-item", (event) => {
                event.preventDefault();
                this.issueClicked(event);
            });

        $(".offline-refresh")
            .off("click.default")
            .on("click.default", () => {
                this.toggleLoader(".offline-refresh", true);
                this.sendOfflineMessage("check-updates");
            });

        $(".offline-download-all")
            .off("click.default")
            .on("click.default", () => {
                this.sendOfflineMessage("download-all");
            });

        $(".offline-logout")
            .off("click.default")
            .on("click.default", () => {
                this.sendOfflineMessage("logout");
            });

        $(".overview-ipad").on("click", () => {
            this.sendOfflineMessage("overview");
        });

        $("#toggle-fullscreen").on("click", () => {
            // document.body.webkitRequestFullscreen();
            this.sendOfflineMessage("fullscreen");
        });

        $(".lang-dropdown-item").on("click", (event) => {
            event.preventDefault();
            this.sendOfflineMessage("language_changed", event.target.href.split("lang=")[1]);
        });
    }

    bindEventListener() {
        $(window).on("offline-message", (event, data) => {
            if (data) {
                switch (data.message) {
                    case "refresh-overview": {
                        let dataHelper = window.frontend.getDataHelper();
                        this.savePositions();

                        window.frontend.start();
                        window.frontend.interface._iscached_filter = false;
                        dataHelper.once(dataHelper.READY, () => {
                            window.frontend.renderHomepage(this._category);
                            this.setScroll();
                        });
                        break;
                    }
                }
            }
        });
    }

    sendOfflineMessage(message, args) {
        if (typeof window.sendOVMessage == "function") {
            window.sendOVMessage(message, args);
        }
    }

    toggleLoader(selector, show) {
        var loader = $(selector).find(".loader");
        if (show) {
            loader.removeClass("hidden");
        } else {
            loader.addClass("hidden");
        }
    }
}
